<div fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="5px" class="box">

  <div fxLayout="row">
    <div fxLayout="row" fxLayoutAlign="start center" class="section-title">Consumption filters</div>
    <div fxFlex></div>
    <lib-button icon="add" tooltip="Add consumption filter" (buttonClick)="addConsumptionFilter()">Add filter</lib-button>
  </div>

  @for (f of filters; track f; let i = $index) {
  <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" class="consumption-filter-item">
    <mat-form-field>
      <mat-label>Wildcard</mat-label>
      <input matInput placeholder="" min="0" max="1000" [(ngModel)]="f.wildCard" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Score</mat-label>
      <input matInput type="number" placeholder="" min="0" max="1000" step=".01" [(ngModel)]="f.score"
        autocomplete="off">
    </mat-form-field>
    <div>
      <lib-button variant="icon" color="primary" icon="delete" tooltip="Remove consumption filter" (buttonClick)="onRemoveConsumptionFilter(i)"></lib-button>
    </div>
  </div>
  }

  @if (!(filters?.length > 0)) {
  <div>
    No consumptions filters
  </div>
  }

</div>